var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createDemoPeriodComparisonMatcher } from '@web/lib/demo/utils';
import { emptyGmailActionsOverTimeCounts, GMAIL_ACTIONS_OVER_TIME_KEYS } from '@workalizer/shared';
import { calculateAverage, getInterval, getPercentageDiff, getPreviousPeriod, groupByPeriod } from '@workalizer/shared/utils';
import { endOfDay, startOfDay } from 'date-fns';
var MOCK_CURRENT_PERIOD_DATA = [
    {
        sent: 42,
        received: 58,
        opened: 35,
        replied: 18,
        linkClicked: 8,
        otherEvents: 12
    },
    {
        sent: 38,
        received: 52,
        opened: 30,
        replied: 15,
        linkClicked: 6,
        otherEvents: 10
    },
    {
        sent: 45,
        received: 61,
        opened: 38,
        replied: 20,
        linkClicked: 9,
        otherEvents: 14
    },
    {
        sent: 40,
        received: 55,
        opened: 32,
        replied: 16,
        linkClicked: 7,
        otherEvents: 11
    },
    {
        sent: 36,
        received: 48,
        opened: 28,
        replied: 14,
        linkClicked: 5,
        otherEvents: 9
    },
    {
        sent: 44,
        received: 60,
        opened: 36,
        replied: 19,
        linkClicked: 8,
        otherEvents: 13
    },
    {
        sent: 39,
        received: 54,
        opened: 31,
        replied: 17,
        linkClicked: 7,
        otherEvents: 11
    }
];
var MOCK_PREV_PERIOD_DATA = [
    {
        sent: 35,
        received: 50,
        opened: 28,
        replied: 14,
        linkClicked: 6,
        otherEvents: 10
    },
    {
        sent: 40,
        received: 55,
        opened: 32,
        replied: 16,
        linkClicked: 7,
        otherEvents: 11
    },
    {
        sent: 32,
        received: 46,
        opened: 25,
        replied: 12,
        linkClicked: 5,
        otherEvents: 8
    },
    {
        sent: 38,
        received: 52,
        opened: 30,
        replied: 15,
        linkClicked: 6,
        otherEvents: 10
    },
    {
        sent: 34,
        received: 48,
        opened: 27,
        replied: 13,
        linkClicked: 5,
        otherEvents: 9
    },
    {
        sent: 41,
        received: 56,
        opened: 33,
        replied: 17,
        linkClicked: 7,
        otherEvents: 12
    },
    {
        sent: 37,
        received: 51,
        opened: 29,
        replied: 14,
        linkClicked: 6,
        otherEvents: 10
    }
];
var MOCK_TEAM_PERIOD_TOTALS = [
    {
        sent: 280,
        received: 360,
        opened: 220,
        replied: 110,
        linkClicked: 48,
        otherEvents: 72
    },
    {
        sent: 256,
        received: 336,
        opened: 200,
        replied: 96,
        linkClicked: 40,
        otherEvents: 64
    },
    {
        sent: 296,
        received: 384,
        opened: 240,
        replied: 120,
        linkClicked: 56,
        otherEvents: 80
    },
    {
        sent: 272,
        received: 352,
        opened: 208,
        replied: 104,
        linkClicked: 44,
        otherEvents: 68
    },
    {
        sent: 248,
        received: 320,
        opened: 192,
        replied: 88,
        linkClicked: 36,
        otherEvents: 56
    },
    {
        sent: 288,
        received: 376,
        opened: 232,
        replied: 116,
        linkClicked: 52,
        otherEvents: 76
    },
    {
        sent: 264,
        received: 344,
        opened: 216,
        replied: 108,
        linkClicked: 42,
        otherEvents: 70
    }
];
var TEAM_USER_COUNT = 8;
export var gmailActionsOverTime = function (input) {
    var interval = getInterval(input.dateFrom, input.dateTo);
    var dateFrom = startOfDay(input.dateFrom);
    var dateTo = endOfDay(input.dateTo);
    var _a = getPreviousPeriod(input.dateFrom, input.dateTo), prevPeriodDateFrom = _a.prevPeriodDateFrom, prevPeriodDateTo = _a.prevPeriodDateTo;
    var periods = groupByPeriod([], dateFrom, dateTo, interval);
    var previousPeriods = groupByPeriod([], startOfDay(prevPeriodDateFrom), endOfDay(prevPeriodDateTo), interval);
    var periodMatcher = createDemoPeriodComparisonMatcher(input, interval, periods, previousPeriods);
    var periodsData = periods.map(function (period, idx) {
        var _a;
        var currentData = MOCK_CURRENT_PERIOD_DATA[idx % MOCK_CURRENT_PERIOD_DATA.length];
        var prevPeriod = periodMatcher.getItem(idx, previousPeriods);
        var previousIndex = prevPeriod
            ? previousPeriods.indexOf(prevPeriod)
            : idx;
        var prevData = MOCK_PREV_PERIOD_DATA[previousIndex % MOCK_PREV_PERIOD_DATA.length];
        var teamTotals = MOCK_TEAM_PERIOD_TOTALS[idx % MOCK_TEAM_PERIOD_TOTALS.length];
        return __assign(__assign({ period: period.date, previousPeriodLabel: (_a = prevPeriod === null || prevPeriod === void 0 ? void 0 : prevPeriod.date) !== null && _a !== void 0 ? _a : '' }, currentData), { prevSent: prevData.sent, prevReceived: prevData.received, prevOpened: prevData.opened, prevReplied: prevData.replied, prevLinkClicked: prevData.linkClicked, prevOtherEvents: prevData.otherEvents, teamSent: input.userId
                ? Math.round(teamTotals.sent / TEAM_USER_COUNT)
                : 0, teamReceived: input.userId
                ? Math.round(teamTotals.received / TEAM_USER_COUNT)
                : 0, teamOpened: input.userId
                ? Math.round(teamTotals.opened / TEAM_USER_COUNT)
                : 0, teamReplied: input.userId
                ? Math.round(teamTotals.replied / TEAM_USER_COUNT)
                : 0, teamLinkClicked: input.userId
                ? Math.round(teamTotals.linkClicked / TEAM_USER_COUNT)
                : 0, teamOtherEvents: input.userId
                ? Math.round(teamTotals.otherEvents / TEAM_USER_COUNT)
                : 0 });
    });
    var currentTotals = periodsData.reduce(function (acc, period) {
        for (var _i = 0, GMAIL_ACTIONS_OVER_TIME_KEYS_1 = GMAIL_ACTIONS_OVER_TIME_KEYS; _i < GMAIL_ACTIONS_OVER_TIME_KEYS_1.length; _i++) {
            var key = GMAIL_ACTIONS_OVER_TIME_KEYS_1[_i];
            acc[key] += period[key];
        }
        return acc;
    }, emptyGmailActionsOverTimeCounts());
    var prevTotals = periodsData.reduce(function (acc, period) {
        acc.sent += period.prevSent;
        acc.received += period.prevReceived;
        acc.opened += period.prevOpened;
        acc.replied += period.prevReplied;
        acc.linkClicked += period.prevLinkClicked;
        acc.otherEvents += period.prevOtherEvents;
        return acc;
    }, emptyGmailActionsOverTimeCounts());
    var teamTotals = MOCK_TEAM_PERIOD_TOTALS.reduce(function (acc, period) {
        for (var _i = 0, GMAIL_ACTIONS_OVER_TIME_KEYS_2 = GMAIL_ACTIONS_OVER_TIME_KEYS; _i < GMAIL_ACTIONS_OVER_TIME_KEYS_2.length; _i++) {
            var key = GMAIL_ACTIONS_OVER_TIME_KEYS_2[_i];
            acc[key] += period[key];
        }
        return acc;
    }, emptyGmailActionsOverTimeCounts());
    return {
        periods: periodsData,
        totals: Object.fromEntries(GMAIL_ACTIONS_OVER_TIME_KEYS.map(function (key) { return [
            key,
            __assign({ current: currentTotals[key], previous: getPercentageDiff(prevTotals[key], currentTotals[key]) }, (input.userId && {
                teamAverage: getPercentageDiff(calculateAverage(teamTotals[key], TEAM_USER_COUNT), currentTotals[key])
            }))
        ]; }))
    };
};
